import { render, staticRenderFns } from "./InferCNV.vue?vue&type=template&id=f93fde50&scoped=true&"
import script from "./InferCNV.vue?vue&type=script&lang=js&"
export * from "./InferCNV.vue?vue&type=script&lang=js&"
import style0 from "./InferCNV.vue?vue&type=style&index=0&id=f93fde50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93fde50",
  null
  
)

export default component.exports